import React from "react";
import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import "./Admin.scss";

const AdminMenu = () => {
	const history = useHistory();
	const {
		location: { pathname },
	} = history;

	let selectedKey = pathname;
	selectedKey = "/shipping-labels";

	return (
		<Menu
			className="MainMenuSme"
			defaultSelectedKeys={[selectedKey]}
			triggerSubMenuAction="hover"
			mode="inline"
		>
			<Menu.Item key="/shipping-labels">
				<Link to="/shipping-labels">Shipping Labels</Link>
			</Menu.Item>
		</Menu>
	);
};

export default AdminMenu;
